import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  snackBarAlert: null
};

export const AlertsSlice = createSlice({
  name: 'AlertsSlice',
  initialState,
  reducers: {
    setSnackBarAlert: (state, action) => {
      state.snackBarAlert = action.payload;
    }
  }
});

export const { setSnackBarAlert } = AlertsSlice.actions;

export default AlertsSlice.reducer;
